module.exports = __webpack_public_path__ + "static/media/img5.03280833.jpg";